<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I’d like to thank Eleonora for her love and support. I also want to thank the people who proofread the manuscript and gave me feedback which I used to improve the story; Jochem Visser, Ton van Uffel, Carl Gustav Bjertnes, Pim van Galen. Thank you Walter Smaalders for designing the book cover. A big thanks to Sue Zimmermann who helped me edit and correct the text and Austin Macauley Publishers for making this book possible.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?cb0faeb8